import React, { useState } from 'react';
import { Mail, Plug } from 'lucide-react';
import TabPageLayout from 'modules/swiftboard/components/TabPageLayout';
import SendgridCredential from './sendgrid-credential/SendgridCredential';
import SendgridConfiguration from './sendgrid-configuration/SendgridConfiguration';
import useUrlTab from "modules/swiftboard/components/useUrlTab";

const EmailSettings = () => {
  const [activeTab, setActiveTab] = useUrlTab(["sendgrid-credential", "sendgrid-configuration"]);
  const [tabCounts, setTabCounts] = useState({});

  const setTabCount = (tabId) => (count) =>
    setTabCounts((prev) => (prev[tabId] === count ? prev : { ...prev, [tabId]: count }));

  const Tabs = [
    {
      id: 1,
      label: 'SendGrid Credential',
      icon: <Mail size={18} />,
    },
    {
      id: 2,
      label: 'SendGrid Configuration',
      icon: <Plug size={18} />,
    },
  ].map((tab, index) => ({
    ...tab,
    badge:
      index === activeTab && tabCounts[tab.id] !== undefined
        ? { count: tabCounts[tab.id], compact: true }
        : undefined,
  }));

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  return (
    <TabPageLayout
      tabs={Tabs}
      activeTab={activeTab}
      onTabChange={handleTabChange}
    >
      {activeTab === 0 && <SendgridCredential onTotalCountChange={setTabCount(1)} />}
      {activeTab === 1 && <SendgridConfiguration onTotalCountChange={setTabCount(2)} />}
    </TabPageLayout>
  );
};

export default EmailSettings;
